import { OscViewComponent } from "./proponente/osc-view/osc-view.component";
import { ConcedenteViewComponent } from "./concedente/concedente-view/concedente-view.component";
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ModuloNaoDisponivelComponent } from "./core/not-found/modulo-nao-disponivel.component";
import { HomePageComponent } from "./home/home/home-page.component";
import { UsuarioViewComponent } from "./home/info/usuario-view/usuario-view.component";
import { MapaComponent } from "./mapa/mapa.component";
import { AuthGuard } from "./seguranca/auth.guard";
import { LoginFormComponent } from "./seguranca/login-form/login-form.component";
import { WrapperComponent } from "./wrapper/wrapper.component";
import { EntidadeViewComponent } from "./home/info/entidade-view/entidade-view.component";
import { TutoriaisComponent } from "./tutoriais/tutoriais.component";
import { AssinadorDocumentosComponent } from "./assinador-documentos/assinador-documentos.component";
import { ConsultaPublicaTutoriaisComponent } from "./tutoriais/consulta-publica/consulta-publica-tutoriais.component";

const routes: Routes = [
  { path: "login", component: LoginFormComponent },
  { path: "mapa", component: MapaComponent, canActivate: [AuthGuard] },
  {
    path: "outras-opcoes",
    loadChildren: () => import('app/outras-opcoes/outras-opcoes.module').then(m => m.OutrasOpcoesModule),
  },
  { path: 'matricula', loadChildren: () => import('app/modulo-escolar/matricula-publica/matricula-publica.module').then(m => m.MatriculaPublicaModule) },
  {
    path: "",
    component: WrapperComponent,
    canActivate: [AuthGuard],
    children: [
      { path: "home", component: HomePageComponent, canActivate: [AuthGuard] },
      {
        path: "usuario-view",
        component: UsuarioViewComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "entidade-view",
        component: EntidadeViewComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: "concedente",
            component: ConcedenteViewComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "proponente",
            component: OscViewComponent,
            canActivate: [AuthGuard],
          },
        ],
      },

      // ===== LAZY-LOADINGS ==== //
      { path: "mapa", component: MapaComponent, canActivate: [AuthGuard] },

      {
        path: "tutoriais",
        component: TutoriaisComponent,
        canActivate: [AuthGuard],
      },

      {
        path: "assinador-documentos",
        component: AssinadorDocumentosComponent,
        canActivate: [AuthGuard],
      },

      {
        path: "cadastros",
        loadChildren: () => import('app/cadastros/cadastros.module').then(m => m.CadastrosModule),
      },

      {
        path: "relatorios",
        loadChildren: () => import('app/relatorios/relatorios.module').then(m => m.RelatoriosModule),
      },

      {
        path: "financeiro",
        loadChildren: () => import('app/financeiro/financeiro.module').then(m => m.FinanceiroModule),
      },

      {
        path: "contabilidade",
        loadChildren: () => import('app/contabilidade/contabilidade.module').then(m => m.ContabilidadeModule),
      },

      {
        path: "editais-credenciamento",
        loadChildren: () => import('app/edital-credenciamento/edital-credenciamento.module').then(m => m.EditalCredenciamentoModule),
      },

      {
        path: "editais-recadastramento",
        loadChildren: () => import('app/edital-credenciamento/edital-credenciamento.module').then(m => m.EditalCredenciamentoModule),
      },

      {
        path: "editais-chamamento",
        loadChildren: () => import('app/edital-chamamento/editalChamamento.module').then(m => m.EditalChamamentoModule),
      },

      {
        path: "notificacao",
        loadChildren: () => import('app/notificacao/notificacao.module').then(m => m.NotificacaoModule),
      },

      {
        path: "dispensa-inexigibilidade",
        loadChildren: () => import('app/dispensa-inexigibilidade/dispensaInexigibilidade.module').then(m => m.DispensaInexigibilidadeModule),
      },

      {
        path: "preparacao",
        loadChildren: () => import('app/preparacao/preparacao.module').then(m => m.PreparacaoModule),
      },

      {
        path: "projetos",
        loadChildren: () => import('app/projetos/projeto.module').then(m => m.ProjetoModule),
      },

      {
        path: "celebracao",
        loadChildren: () => import('app/celebracao/celebracao.module').then(m => m.CelebracaoModule),
      },

      { path: "planos", loadChildren: () => import('app/plano/plano.module').then(m => m.PlanoModule) },

      {
        path: "patrocinio",
        loadChildren: () => import('app/patrocinio/patrocinio.module').then(m => m.PatrocinioModule),
      },

      {
        path: "pmis",
        loadChildren: () => import('app/manifestacao-interesse/manifestacao-interesse.module').then(m => m.ManifestacaoInteresseModule),
      },

      {
        path: "execucao",
        loadChildren: () => import('app/execucao/execucao.module').then(m => m.ExecucaoModule),
      },

      {
        path: "prestacao-contas",
        loadChildren: () => import('app/prestacao-contas/prestacao-contas.module').then(m => m.PrestacaoContasModule),
      },

      {
        path: "habilitacao",
        loadChildren: () => import('app/habilitacao/habilitacao.module').then(m => m.HabilitacaoModule),
      },

      {
        path: "termos",
        loadChildren: () => import('app/modelo-termo/modelo-termo.module').then(m => m.ModeloTermoModule),
      },

      {
        path: "controle-interno",
        loadChildren: () => import('app/controle-interno/controle-interno.module').then(m => m.ControleInternoModule),
      },

      { path: "modelo", loadChildren: () => import('app/modelo/modelo.module').then(m => m.ModeloModule) },

      {
        path: "tributos",
        loadChildren: () => import('app/tributos/tributos.module').then(m => m.TributosModule),
      },

      { path: "frota", loadChildren: () => import('app/frota/frota.module').then(m => m.FrotaModule) },

      {
        path: "perfil-permissao",
        loadChildren: () => import('app/perfil-permissao/perfil-permissao.module').then(m => m.PerfilPermissaoModule),
      },

      {
        path: "administracao",
        loadChildren: () => import('app/administracao/administracao.module').then(m => m.AdministracaoModule),
      },

      {
        path: "pendencia",
        loadChildren: () => import('app/pendencia/pendencia.module').then(m => m.PendenciaModule),
      },

      { path: 'projetos-concluidos', loadChildren: () => import('app/projetos-concluidos/projetos-concluidos.module').then(m => m.ProjetosConcluidosModule) },
      
      // ===== MODULO ESCOLAR ==== //

      { path: 'educacao-escolar', loadChildren: () => import('app/modulo-escolar/escolar.module').then(m => m.EscolarModule) },
    ]
  },

  {
    path: "proposta",
    loadChildren: () => import('app/proposta/proposta.module').then(m => m.PropostaModule),
  },
  { path: "tutoriais-publicos", component: ConsultaPublicaTutoriaisComponent },
  { path: "modulo-nao-disponivel", component: ModuloNaoDisponivelComponent },
  { path: "**", redirectTo: "modulo-nao-disponivel" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
